import { z } from 'zod';
import { ProductSummarySchema } from './product.model';

export type CartItem = z.infer<typeof CartItemSchema>;
export const CartItemSchema = z.object({
  id: z.string().nonempty("CartItem ID is required."),
  price: z.number().positive("Price must be positive.").min(0.01, "Price must be at least 0.01."),
  summary: ProductSummarySchema,
  quantity: z.number().int("Quantity must be an integer.").min(1, "Quantity must be at least 1.")
});

export type Cart = z.infer<typeof CartSchema>;
export const CartSchema = z.object({
  currency: z.string().nonempty("Currency is required."),
  items: z.array(CartItemSchema),
  total: z.number().min(0, "Total price must be at least 0.")
});
